module.exports = __webpack_public_path__ + "img/weibo-icon.f5db0d0c.png";